<template>
  <div
    class="flex flex-wrap border-dashed border-b-2 border-pink-light py-1"
    @click="openTab"
  >
    <div class="flex-1">
      <p>{{ classe.name }} {{ classe.surname }}</p>
    </div>
    <div
      class="flex-1 text-right"
      v-if="showContact"
    >
      <img
        src="/img/hand.png"
        style="width: 20px"
      >
    </div>
    <div
      v-if="showContact"
      class="w-full flex-wrap py-2"
      :class="{ hidden: !open, flex: open }"
    >
      <div
        class="flex-1"
        v-for="genitore in classe.admin_tutors"
        :key="genitore.id"
      >
        <div v-if="genitore.show_contacts">
          <p
            class="text-xs pt-2 pb-3"
            @click="clickContact"
          >
            <a
              :href="`tel:${genitore.phone}`"
              target="_blank"
              class="text-grey no-underline border py-1 px-2 rounded-full border-yellow"
            >
              {{ genitore.phone }}
            </a>
          </p>
          <p>
            <small class="pl-2">{{ genitore.name }}</small>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['classe', 'showContact'],
  data() {
    return {
      open: false,
    };
  },
  methods: {
    openTab() {
      this.open = !this.open;
    },
    clickContact() {
      this.open = false;
    },
  },
};
</script>
